var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"d-flex"},[(!this.$route.path.includes('login'))?_c('side_nav'):_vm._e(),_c('v-main',[_c('router-view')],1)],1),_c('snackbar'),_c('progressBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }